import {ICookiesService} from "./cookies.service.interface";

export class CookiesService implements ICookiesService {
    constructor() {
        const now = new Date();
        now.setFullYear(now.getFullYear() + 1);
        const expirationDate = now.toUTCString();
        document.cookie = 'lastproduct=casino;expires=' + expirationDate + ';path=/';
    }

    createCookie(name: string, value: string, expiration_date?:Date): void {
        let expirationDate;
        if (expiration_date) {
            expirationDate = expiration_date.toUTCString()
        } else {
            let now = new Date();
            now.setFullYear(now.getFullYear() + 1);
            expirationDate = now.toUTCString();
        }
        document.cookie = name + '=' + value + ';expires=' + expirationDate+ ';path=/';
    }

    createDomainCookie(name: string, value: string): void {
        let now = new Date();
        now.setFullYear(now.getFullYear() + 1);
        document.cookie = name + '=' + value + ';domain=.' + this.getDomain() + ';expires=' + now.toUTCString() + ';path=/';
    }

    getCookie(name: string) {
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) {
            return match[1];
        }
    }

    removeCookie(name: string): void {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=." + this.getDomain() + ";";
    }

    private getDomain() {
        // use hostname not host because host includes the port (ex: localhost:7070) while hostname doesn't
        const hostnameParts = window.location.hostname.split(".");
        if (hostnameParts.length === 1) {
            // that is localhost
            return hostnameParts[0];
        }
        // uk domains: example.co.uk
        if (
            hostnameParts.length >= 3 &&
            hostnameParts[hostnameParts.length - 1] === "uk" &&
            hostnameParts[hostnameParts.length - 2] === "co"
        ) {
            return hostnameParts.slice(-3).join(".");
        }
        return hostnameParts.slice(-2).join(".");
    }
}